<template>
  <div class="kt-footer kt-grid__item kt-grid--desktop kt-grid--ver-desktop" id="kt_footer">
    <div class="kt-container kt-container--fluid">
      <div class="kt-footer__copyright">
        Copyright&nbsp;&copy;{{ site.meta.default.copyright_year }}
        <a :href="site.url" target="_blank" class="ml-1">{{ site.title }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapGetters({
      site: 'site/site'
    })
  },
};
</script>
